// VF Asset Transfer(rights scope) 를 LA&SC Rights Scope 처럼 가로 테이블로 렌더할 때
// 헤더 행과 셀이 동일한 컬럼 폭을 공유하도록 한 곳에서 관리한다.
export const ASSET_TRANSFER_COLUMNS = [
  { shellKey: "Drug", label: "Drug / Asset", width: "20.4rem" },
  { shellKey: "Indication", label: "Intended Use", width: "20.4rem" },
  { shellKey: "Exclusivity", label: "Exclusivity", width: "20.4rem" },
  { shellKey: "Territory", label: "Territory", width: "20.4rem" },
  { shellKey: "Territory Include", label: "Include", width: "20.4rem" },
  { shellKey: "Territory Exclude", label: "Exclude", width: "20.4rem" },
] as const;

export const ASSET_TRANSFER_COLUMN_WIDTH: Record<string, string> =
  ASSET_TRANSFER_COLUMNS.reduce(
    (acc, column) => ({ ...acc, [column.shellKey]: column.width }),
    {} as Record<string, string>,
  );

export const ASSET_TRANSFER_SHELL_KEYS = ASSET_TRANSFER_COLUMNS.map(
  (column) => column.shellKey as string,
);
